module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/notification/notification.component.css
// module id = ./src/app/notification/notification.component.css
// module chunks = main